import api from '../../api/apiSlice';

export type CustomerHistory = 'render' | 'delivery';
export type RecomputeMode = 'update' | 'rebuild';

type CustomerHistoryRecompute = {
  readonly customerId: string;
  readonly history: CustomerHistory;
  readonly mode: RecomputeMode;
};

type DealUsageRecompute = {
  readonly dealId: string;
};

export const insightRecomputeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    recomputeCustomerHistory: builder.mutation<void, CustomerHistoryRecompute>({
      query: ({ customerId, history, mode }) => ({
        url: `/insight/customers/${encodeURIComponent(customerId)}/history-recomputes`,
        method: 'POST',
        body: { history, mode },
      }),
    }),
    recomputeDealUsage: builder.mutation<void, DealUsageRecompute>({
      query: ({ dealId }) => ({ url: `/insight/deals/${encodeURIComponent(dealId)}/usage-recomputes`, method: 'POST' }),
    }),
  }),
});

export const { useRecomputeCustomerHistoryMutation, useRecomputeDealUsageMutation } = insightRecomputeApi;
